import {WarehouseLogin} from 'constants/WarehouseConstants';
import {RESTWarehouseParameter} from 'insights/parameters/RESTParameterTypes';
import * as net from 'util/Net';

interface WarehouseLogins {
  logins: Array<WarehouseLogin>;
}

export interface CreateUserDefinedViewRequest {
  view_name: string;
  view_query: string;
  view_description: string;
  origin_analytics_query_api_identifier: string;
  parameters?: Array<RESTWarehouseParameter>;
}

export interface CreateUserDefinedViewResponse {}

/** Snowflake connection details an outbound data-sharing consumer (e.g. Databricks) uses. */
export interface DataSharingConnectionInfo {
  host: string;
  accountIdentifier: string;
  catalogName: string;
  namespace: string;
  sharedNamespace: string;
  readRole: string;
  readerUser: string;
  readerWarehouse: string;
  catalogUri: string;
  tokenEndpoint: string;
  programmaticAccessToken: string;
}

export function fetchDataSharingConnectionInfo(): Promise<DataSharingConnectionInfo> {
  return net.getJSONPromise('/1/api/warehouse/data-sharing/connection-info');
}

export function fetchLogins(): Promise<WarehouseLogins> {
  return Promise.resolve(net.getJSON('/1/api/warehouse/logins'));
}

export function createLogin(label: string): Promise<WarehouseLogin> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/warehouse/logins',
      data: {label},
    })
  );
}

export function revokeLogin(login: WarehouseLogin): Promise<WarehouseLogin> {
  return Promise.resolve(net.delete_({url: `/1/api/warehouse/logins/${login.id}`}));
}

export function createUserDefinedView(
  data: CreateUserDefinedViewRequest
): Promise<CreateUserDefinedViewResponse> {
  return net.postJSONPromise({
    url: '/1/api/warehouse/user-defined-views',
    data,
  });
}

export function deleteUserDefinedView(viewId: string): Promise<void> {
  return net.deletePromise({
    url: `/1/api/warehouse/user-defined-views/${viewId}`,
  });
}

export function refreshUserDefinedView(viewId: string): Promise<void> {
  return net.postJSONPromise({
    url: `/1/api/warehouse/user-defined-views/${viewId}/refresh-warehouse-existence-status`,
    data: {},
  });
}
